"use client";

import { c as _c } from "react/compiler-runtime";
import { InputAdornment, TextField } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useState } from "react";
const PasswordField = props => {
  const $ = _c(11);
  const [showPassword, setShowPassword] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setShowPassword(_temp);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleTogglePassword = t0;
  const t1 = showPassword ? "text" : "password";
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      cursor: "pointer"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== showPassword) {
    t3 = {
      endAdornment: <InputAdornment position="end" onClick={handleTogglePassword} style={t2}>{showPassword ? <Visibility /> : <VisibilityOff />}</InputAdornment>
    };
    $[2] = showPassword;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      shrink: true
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = {
      input: t3,
      inputLabel: t4
    };
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== props || $[8] !== t1 || $[9] !== t5) {
    t6 = <TextField {...props} label="Password" type={t1} variant="outlined" fullWidth={true} margin="normal" name="password" slotProps={t5} />;
    $[7] = props;
    $[8] = t1;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default PasswordField;
function _temp(prev) {
  return !prev;
}